module.exports = global["jQuery"] = require("-!D:\\Sites\\html.xively.com\\node_modules\\expose-loader\\index.js?$!D:\\Sites\\html.xively.com\\node_modules\\jquery\\dist\\jquery.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/dist/jquery.js
 ** module id = 1
 ** module chunks = 0
 **/